export default __webpack_public_path__ + "static/media/V180_CoC.cc0f365d.pdf";